let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aI8Mo")).then(() => parcelRequire('l7AbD'));